<script setup lang="ts">
import RichResponseListItem from "@/views/Chat/RichResponses/components/RichResponseListItem.vue";
import {IonIcon, IonLabel, IonToggle} from "@ionic/vue";
import {DemandJoDaShTi, DemandJoDaShTiFragment, Jobsite} from "@/graphql/generated/graphql";
import {computed, PropType, Ref, ref} from "vue";
import datetimeRange from "@/helper/datetime/datetimeRange";
import {KapitelIcon} from "@/helper/icon";
import JobsiteDetails from "@/views/JobsiteDetails.vue";

const props = defineProps({
    joDaShTi: {
        type: Object as PropType<DemandJoDaShTiFragment>,
        required: true
    },
    showJobsiteLabel: {
        type: Boolean,
        required: false,
        default: false
    },
    considered: Boolean,
    toggleable: {
        type: Boolean,
        default: true,
        required: false,
    },
    toggleState: Boolean,
})

const worktime = computed(() => datetimeRange.formatTimeRangeObject(props.joDaShTi))

const emit = defineEmits<{
    toggle: [state: boolean, d: DemandJoDaShTiFragment]
}>()

const state: Ref<boolean> = ref(props.toggleState)

const onToggle = () => {
    state.value = !state.value
    emit("toggle", state.value, props.joDaShTi);
};

const autopilotConsiderationColor = computed(() => props.considered ? 'success' : 'dark')

const autopilotConsiderationLabel = computed(() => {
    if (props.considered && !props.toggleState) {
        return 'Verfügbar für diesen Dienst über die Einstellungen der Monatsplanung'
    } else if (props.considered && props.toggleState) {
        return 'Für diesen Dienst verfügbar'
    } else if (!props.considered && props.toggleState) {
        return 'Aktuell anderweitig besetzt, dennoch für diesen Dienst verfügbar'
    }else {
        return 'Aktuell nicht verfügbar für diesen Dienst'
    }
})

const showJobsiteDetailsModalModel : Ref<number|undefined> = ref(undefined)

</script>

<template>
    <RichResponseListItem
        :icon="props.joDaShTi.shiftType"
        icon-type="text"
        :icon-color="autopilotConsiderationColor"
    >
        <template #title>
            <template v-if="props.showJobsiteLabel">
                {{ props.joDaShTi.jobsite.abbreviation }}
                <a @click="() => showJobsiteDetailsModalModel = props.joDaShTi.jobsite.id">
                    <IonIcon :icon="KapitelIcon.infoFill"  class="globalTextAlignedIcon"/>
                </a>
                <JobsiteDetails v-model="showJobsiteDetailsModalModel" :showJobsiteDemandModalLink="false" />
                <br/>
            </template>
            {{ worktime }}
        </template>

        <template #default>
            <IonLabel :color="autopilotConsiderationColor">{{autopilotConsiderationLabel}}</IonLabel>
        </template>

        <template #end v-if="props.toggleable">
            <IonToggle :color="autopilotConsiderationColor" :checked="props.toggleState" @ionChange="onToggle"/>
        </template>
    </RichResponseListItem>
</template>

<style scoped lang="scss">

</style>
